module.exports = __webpack_public_path__ + "media/icons/switch_black@2x-1b6fde0e.png";